export default __webpack_public_path__ + "dfa4b01ee6507eab29ed1326df75e356.png";